import React from 'react';
import PropTypes from 'prop-types';

import ColorProvider from '../chrome/ColorProvider';
import Text from '../chrome/Text';

const TermsText = ({ variant, text, ...props }) => (
  <ColorProvider variant={variant}>
    <Text size='kilo' centered {...props}>
      {text}
    </Text>
  </ColorProvider>
);

TermsText.propTypes = {
  variant: PropTypes.string,
  text: PropTypes.string,
};

TermsText.defaultProps = {
  variant: 'darkGrey',
};

export default TermsText;
